import Header from '../compnents/header'; 
import Footer from '../compnents/footer'; 
import Sidebar from '../compnents/Sidebar'; 
import '../assets/css/maincss.css';
import React, { useContext } from 'react';
import MyContext from '../contextapi/MyContext';


const Dashboardlayout = ({children}) =>{
    const mycontext = useContext(MyContext);
    return(
      <>
        <div className='container-box'> 
         <div className={mycontext.value}>
           <Sidebar/>   
         </div>
         <div className={mycontext.contentboxval}>
         <Header/>
            <div className='inner-content-box'>
              {children}
            </div>
           <Footer/>
         </div>
        </div>
      </>
    );   
 }
 
 export default Dashboardlayout;